import { createContext, type ReactNode, useContext } from 'react';
import type { LocationCredential, StartupSessionSnapshot } from '@/app/session/startup-session';

interface StartupSessionContextValue {
  activeLocation: LocationCredential | null;
  changeLocation: () => void;
  snapshot: StartupSessionSnapshot;
}

const StartupSessionContext = createContext<StartupSessionContextValue | null>(null);

export function StartupSessionProvider({
  children,
  onChangeLocation,
  snapshot,
}: {
  children: ReactNode;
  onChangeLocation: () => void;
  snapshot: StartupSessionSnapshot;
}) {
  const activeLocation = snapshot.locations.find(location => location.id === snapshot.selectedLocationId) ?? null;

  return (
    <StartupSessionContext.Provider value={{ activeLocation, changeLocation: onChangeLocation, snapshot }}>
      {children}
    </StartupSessionContext.Provider>
  );
}

export function useStartupSession() {
  const value = useContext(StartupSessionContext);

  if (!value) {
    throw new Error('useStartupSession must be used inside StartupSessionProvider.');
  }

  return value;
}
